"use client";
import { useStore } from "@nanostores/react";
import { SecondaryButton } from "ui/components";
import { Filter } from "../newIcons/Filter";
import { isFiltersOpenStore } from "./search/filters/store";
import { Sort } from "./search/searchHead/Sort";

export const MobileSubBar = () => {
  const isFiltersOpen = useStore(isFiltersOpenStore);

  return (
    <div className="flex pt-3 px-3 justify-between sm:justify-evenly md:hidden">
      <SecondaryButton size="sm" onClick={() => isFiltersOpenStore.set(!isFiltersOpen)}>
        <Filter className="w-4 h-4 mr-[5px]" />
        FILTRER
      </SecondaryButton>
      <Sort />
    </div>
  );
};
